<div class="container-fluid">
    <div class="row product-adding">
        <div class="col-xl-12">
            <div class="card">
                <!-- <div class="card-header">
                    <h5>إضافة منتج جديد</h5>
                </div> -->
                <div class="card-body">

                    <form [formGroup]="myForm" *ngIf="!isSubmit" (ngSubmit)="onSave()">

                        <div class="modal-body">

                            <div class="form-group row1col">
                                <mat-form-field>
                                    <input formControlName="controlPhone" matInput placeholder="رقم التليفون - عربي">
                                    <mat-error *ngIf="hasError('controlPhone','required')"> برجاء كتابة رقم التليفون
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        </div>

                        <div class="modal-footer">
                            <button type="submit" class="btn btn-primary">Save</button>
                            <!-- <button class="btn btn-secondary" type="button">Close</button> -->
                        </div>
                    </form>
                    <app-loading *ngIf="isSubmit" [progress]="progress"></app-loading>

                </div>
            </div>
        </div>
    </div>
</div>